import { v4 as generateUUIDv4 } from 'uuid';
import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import { generateHMACKey } from '~/utils/hmacKeyCreation';
import { useEnvPropsStore } from '~/stores/envProps';
import { useGoogleSecretsStore } from '~/stores/googleSecrets';

const httpGetNonProtectedAPIHeaders = (optionalHeaders = {}) => {
  const googleSecretsStore = useGoogleSecretsStore();

  return {
    'x-macys-request-id': generateUUIDv4(),
    'x-macys-apikey': googleSecretsStore.xMacysApiKey,
    'x-macys-dca': Cookie.get('dca'),
    Accept: 'application/json',
    ...optionalHeaders,
  };
};

const httpGetProtectedAPIHeaders = (optionalHeaders = {}) => {
  const envPropsStore = useEnvPropsStore();

  return {
    macys_online_uid: encodeURIComponent(
      Cookie.get(envPropsStore.envProps?.entryPoint.toUpperCase() === 'BCOM' ? 'bloomingdales_online_uid' : 'macys_online_uid'),
    ),
    host: envPropsStore?.envProps?.siteDomain,
    'x-macys-securitytoken': encodeURIComponent(Cookie.get('secure_user_token')),
    ...(!envPropsStore?.envProps?.siteDomain?.includes('macys') &&
      !envPropsStore?.envProps?.siteDomain?.includes('bloomingdales') && {
        'x-macys-client-host': envPropsStore?.envProps?.siteDomain?.split('.')[1],
      }),
    ...httpGetNonProtectedAPIHeaders(optionalHeaders),
  };
};

const httpUpdateAPIHeaders = (hmacKeyPayload, optionalHeaders = {}, onlineGuid = false) => {
  const envPropsStore = useEnvPropsStore();
  const googleSecretsStore = useGoogleSecretsStore();

  return {
    'Content-Type': 'application/json',
    HMAC: generateHMACKey(hmacKeyPayload, googleSecretsStore.hmacKey),
    ...httpGetProtectedAPIHeaders(optionalHeaders),
    ...(onlineGuid && {
      macys_online_guid: encodeURIComponent(
        Cookie.get(envPropsStore?.envProps?.entryPoint.toUpperCase() === 'BCOM' ? 'bloomingdales_online_guid' : 'macys_online_guid'),
      ),
    }),
  };
};

export { httpGetNonProtectedAPIHeaders, httpGetProtectedAPIHeaders, httpUpdateAPIHeaders };
